import { Skeleton } from '@/components/ui/skeleton';
import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import {
  ACTIONS_COLUMN_ID,
  BODY_CELL_PADDING_CLASS,
  BODY_ROW_CLASS,
  SERIAL_COLUMN_ID,
} from './dataTable.constants';

const MAIN_LINE_BOX_CLASS = 'flex h-5 items-center';
const DETAIL_LINE_BOX_CLASS = 'flex h-4 items-center';

interface DataTableLoadingProps {
  columnCount: number;
  rowCount: number;
  columnIds?: readonly string[] | undefined;
}

interface SkeletonCellProps {
  columnId: string | undefined;
}

function SkeletonCell({ columnId }: SkeletonCellProps) {
  if (columnId === ACTIONS_COLUMN_ID) {
    return <Skeleton className="h-7 w-16 rounded-md" />;
  }
  if (columnId === SERIAL_COLUMN_ID) {
    return (
      <span className={MAIN_LINE_BOX_CLASS}>
        <Skeleton className="h-3.5 w-5" />
      </span>
    );
  }
  return (
    <span className="flex flex-col">
      <span className={MAIN_LINE_BOX_CLASS}>
        <Skeleton className="h-3.5 w-4/5" />
      </span>
      <span className={DETAIL_LINE_BOX_CLASS}>
        <Skeleton className="h-3 w-1/2" />
      </span>
    </span>
  );
}

export function DataTableLoading({ columnCount, rowCount, columnIds }: DataTableLoadingProps) {
  const rowKeys = Array.from({ length: rowCount }, (_, row) => `skeleton-row-${row}`);
  const columnKeys = Array.from({ length: columnCount }, (_, column) => `skeleton-col-${column}`);

  return (
    <>
      {rowKeys.map((rowKey) => (
        <TableRow key={rowKey} className={cn('hover:bg-transparent', BODY_ROW_CLASS)}>
          {columnKeys.map((columnKey, columnIndex) => (
            <TableCell
              key={`${rowKey}-${columnKey}`}
              className={cn(BODY_CELL_PADDING_CLASS, 'whitespace-nowrap')}
            >
              <SkeletonCell columnId={columnIds?.[columnIndex]} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
